export default __webpack_public_path__ + "static/media/12-32-27.c2893f74.jpg";